var _rect, _mask, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FDF4E5",
    stroke: "#FFF6E5",
    strokeWidth: 4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1942 27.3115V28.8062H11.5991C11.4931 28.8062 11.3915 28.7641 11.3165 28.6891C11.2416 28.6142 11.1995 28.5125 11.1995 28.4065V27.3115H14.1942Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1835 27.3114H11.1995C11.2064 27.2102 11.2516 27.1155 11.3258 27.0463C11.4 26.9772 11.4977 26.9389 11.5991 26.9391H16.7838C16.8853 26.9389 16.983 26.9772 17.0572 27.0463C17.1314 27.1155 17.1765 27.2102 17.1835 27.3114Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1834 27.3389V28.4339C17.1841 28.4866 17.1743 28.5389 17.1545 28.5877C17.1346 28.6365 17.1052 28.6809 17.068 28.7181C17.0307 28.7554 16.9863 28.7848 16.9375 28.8046C16.8887 28.8244 16.8364 28.8343 16.7837 28.8335H14.1941V27.3115H17.1834V27.3389Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0534 27.224H11.6428V28.5215H12.0534V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8364 27.224H12.4258V28.5215H12.8364V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6196 27.224H13.209V28.5215H13.6196V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4023 27.224H13.9917V28.5215H14.4023V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1797 27.224H14.769V28.5215H15.1797V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9626 27.224H15.552V28.5215H15.9626V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7453 27.224H16.3347V28.5215H16.7453V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1942 29.1839V30.6786H11.5991C11.4931 30.6786 11.3915 30.6365 11.3165 30.5615C11.2416 30.4866 11.1995 30.3849 11.1995 30.2789V29.1839H14.1942Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1835 29.1841H11.1995C11.2051 29.0819 11.2496 28.9858 11.324 28.9155C11.3983 28.8452 11.4968 28.8062 11.5991 28.8063H16.7838C16.8861 28.8062 16.9846 28.8452 17.059 28.9155C17.1333 28.9858 17.1779 29.0819 17.1835 29.1841Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1834 29.2168V30.3118C17.1834 30.4178 17.1413 30.5194 17.0663 30.5944C16.9914 30.6693 16.8897 30.7114 16.7837 30.7114H14.1941V29.1839H17.1834V29.2168Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0534 29.0963H11.6428V30.3939H12.0534V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8364 29.0963H12.4258V30.3939H12.8364V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6196 29.0963H13.209V30.3939H13.6196V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4023 29.0963H13.9917V30.3939H14.4023V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1797 29.0963H14.769V30.3939H15.1797V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9626 29.0963H15.552V30.3939H15.9626V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7453 29.0963H16.3347V30.3939H16.7453V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1942 31.0508V32.5454H11.5991C11.4931 32.5454 11.3915 32.5033 11.3165 32.4284C11.2416 32.3534 11.1995 32.2518 11.1995 32.1458V31.0508H14.1942Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1835 31.0513H11.1995C11.2064 30.9502 11.2516 30.8554 11.3258 30.7863C11.4 30.7171 11.4977 30.6788 11.5991 30.679H16.7838C16.8853 30.6788 16.983 30.7171 17.0572 30.7863C17.1314 30.8554 17.1765 30.9502 17.1835 31.0513Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1834 31.0782V32.1731C17.1841 32.2258 17.1743 32.2781 17.1545 32.3269C17.1346 32.3758 17.1052 32.4201 17.068 32.4574C17.0307 32.4946 16.9863 32.524 16.9375 32.5439C16.8887 32.5637 16.8364 32.5735 16.7837 32.5728H14.1941V31.0508H17.1834V31.0782Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0534 30.9632H11.6428V32.2608H12.0534V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8364 30.9632H12.4258V32.2608H12.8364V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6196 30.9632H13.209V32.2608H13.6196V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4023 30.9632H13.9917V32.2608H14.4023V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1797 30.9632H14.769V32.2608H15.1797V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9626 30.9632H15.552V32.2608H15.9626V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7453 30.9632H16.3347V32.2608H16.7453V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7257 27.3115V28.8062H18.1361C18.0832 28.8069 18.0306 28.7971 17.9815 28.7773C17.9323 28.7576 17.8876 28.7282 17.8499 28.6911C17.8123 28.6539 17.7823 28.6096 17.7619 28.5607C17.7415 28.5119 17.731 28.4594 17.731 28.4065V27.3115H20.7257Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7149 27.3114H17.7363C17.7433 27.2102 17.7884 27.1155 17.8626 27.0463C17.9369 26.9772 18.0346 26.9389 18.136 26.9391H23.3152C23.4166 26.9389 23.5144 26.9772 23.5886 27.0463C23.6628 27.1155 23.7079 27.2102 23.7149 27.3114Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7206 27.3389V28.4339C23.7206 28.4868 23.7101 28.5392 23.6896 28.5881C23.6692 28.6369 23.6393 28.6812 23.6016 28.7184C23.5639 28.7556 23.5192 28.7849 23.4701 28.8047C23.4209 28.8245 23.3684 28.8343 23.3154 28.8335H20.7258V27.3115H23.7151C23.7195 27.3199 23.7214 27.3294 23.7206 27.3389Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5905 27.224H18.1799V28.5215H18.5905V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3679 27.224H18.9573V28.5215H19.3679V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1508 27.224H19.7402V28.5215H20.1508V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9338 27.224H20.5232V28.5215H20.9338V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7168 27.224H21.3062V28.5215H21.7168V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4941 27.224H22.0835V28.5215H22.4941V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2771 27.224H22.8665V28.5215H23.2771V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7257 25.4447V26.9393H18.1361C18.0296 26.9393 17.9274 26.8974 17.8515 26.8226C17.7757 26.7478 17.7324 26.6461 17.731 26.5396V25.4447H20.7257Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7149 25.4448H17.7363C17.7419 25.3427 17.7865 25.2465 17.8609 25.1763C17.9352 25.106 18.0337 25.0669 18.136 25.067H23.3152C23.4175 25.0669 23.516 25.106 23.5904 25.1763C23.6647 25.2465 23.7093 25.3427 23.7149 25.4448Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7206 25.4666V26.5615C23.7191 26.668 23.6758 26.7697 23.6 26.8445C23.5242 26.9193 23.422 26.9612 23.3154 26.9612H20.7258V25.4447H23.7151C23.7195 25.4511 23.7214 25.4589 23.7206 25.4666Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5905 25.3571H18.1799V26.6546H18.5905V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3679 25.3571H18.9573V26.6546H19.3679V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1508 25.3571H19.7402V26.6546H20.1508V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9338 25.3571H20.5232V26.6546H20.9338V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7168 25.3571H21.3062V26.6546H21.7168V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4941 25.3571H22.0835V26.6546H22.4941V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2771 25.3571H22.8665V26.6546H23.2771V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7257 29.1839V30.6786H18.1361C18.0296 30.6786 17.9274 30.6366 17.8515 30.5618C17.7757 30.4871 17.7324 30.3854 17.731 30.2789V29.2168L20.7257 29.1839Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7149 29.1841H17.7363C17.7419 29.0819 17.7865 28.9858 17.8609 28.9155C17.9352 28.8452 18.0337 28.8062 18.136 28.8063H23.3152C23.4175 28.8062 23.516 28.8452 23.5904 28.9155C23.6647 28.9858 23.7093 29.0819 23.7149 29.1841Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7206 29.2168V30.3118C23.7191 30.4183 23.6758 30.5199 23.6 30.5947C23.5242 30.6695 23.422 30.7114 23.3154 30.7114H20.7258V29.1839H23.7151C23.7189 29.1884 23.7214 29.1938 23.7223 29.1996C23.7233 29.2054 23.7227 29.2113 23.7206 29.2168Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5905 29.0963H18.1799V30.3939H18.5905V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3679 29.0963H18.9573V30.3939H19.3679V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1508 29.0963H19.7402V30.3939H20.1508V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9338 29.0963H20.5232V30.3939H20.9338V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7168 29.0963H21.3062V30.3939H21.7168V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4941 29.0963H22.0835V30.3939H22.4941V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2771 29.0963H22.8665V30.3939H23.2771V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7257 31.0508V32.5454H18.1361C18.0832 32.5461 18.0306 32.5363 17.9815 32.5166C17.9323 32.4968 17.8876 32.4675 17.8499 32.4303C17.8123 32.3931 17.7823 32.3488 17.7619 32.3C17.7415 32.2511 17.731 32.1987 17.731 32.1458V31.0508H20.7257Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7149 31.0513H17.7363C17.7433 30.9502 17.7884 30.8554 17.8626 30.7863C17.9369 30.7171 18.0346 30.6788 18.136 30.679H23.3152C23.4166 30.6788 23.5144 30.7171 23.5886 30.7863C23.6628 30.8554 23.7079 30.9502 23.7149 31.0513Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7206 31.0782V32.1731C23.7206 32.2261 23.7101 32.2785 23.6896 32.3274C23.6692 32.3762 23.6393 32.4205 23.6016 32.4577C23.5639 32.4949 23.5192 32.5242 23.4701 32.544C23.4209 32.5637 23.3684 32.5735 23.3154 32.5728H20.7258V31.0508H23.7151C23.7195 31.0592 23.7214 31.0687 23.7206 31.0782Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5905 30.9632H18.1799V32.2608H18.5905V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3679 30.9632H18.9573V32.2608H19.3679V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1508 30.9632H19.7402V32.2608H20.1508V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9338 30.9632H20.5232V32.2608H20.9338V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7168 30.9632H21.3062V32.2608H21.7168V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4941 30.9632H22.0835V32.2608H22.4941V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2771 30.9632H22.8665V32.2608H23.2771V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2681 27.3115V28.8062H24.6675C24.6148 28.8069 24.5625 28.7971 24.5137 28.7772C24.4649 28.7574 24.4205 28.728 24.3833 28.6907C24.346 28.6535 24.3166 28.6091 24.2968 28.5603C24.277 28.5115 24.2671 28.4592 24.2679 28.4065V27.3115H27.2681Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2519 27.3114H24.2678C24.2748 27.2102 24.3199 27.1155 24.3941 27.0463C24.4683 26.9772 24.5661 26.9389 24.6675 26.9391H29.8522C29.9536 26.9389 30.0513 26.9772 30.1255 27.0463C30.1998 27.1155 30.2449 27.2102 30.2519 27.3114Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2519 27.3389V28.4339C30.2519 28.5399 30.2098 28.6415 30.1348 28.7165C30.0599 28.7914 29.9582 28.8335 29.8522 28.8335H27.2681V27.3115H30.2628L30.2519 27.3389Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.122 27.224H24.7114V28.5215H25.122V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9048 27.224H25.4941V28.5215H25.9048V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6823 27.224H26.2717V28.5215H26.6823V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4653 27.224H27.0547V28.5215H27.4653V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2483 27.224H27.8376V28.5215H28.2483V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.031 27.224H28.6204V28.5215H29.031V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8086 27.224H29.3979V28.5215H29.8086V27.224Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2681 25.4447V26.9393H24.6675C24.5615 26.9393 24.4598 26.8972 24.3849 26.8223C24.3099 26.7473 24.2678 26.6456 24.2678 26.5396V25.4447H27.2681Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2519 25.4448H24.2678C24.2734 25.3427 24.318 25.2465 24.3924 25.1763C24.4667 25.106 24.5652 25.0669 24.6675 25.067H29.8522C29.9545 25.0669 30.053 25.106 30.1273 25.1763C30.2017 25.2465 30.2462 25.3427 30.2519 25.4448Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2519 25.4666V26.5615C30.2519 26.6675 30.2098 26.7692 30.1348 26.8442C30.0599 26.9191 29.9582 26.9612 29.8522 26.9612H27.2681V25.4447H30.2628L30.2519 25.4666Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.122 25.3571H24.7114V26.6546H25.122V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9048 25.3571H25.4941V26.6546H25.9048V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6823 25.3571H26.2717V26.6546H26.6823V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4653 25.3571H27.0547V26.6546H27.4653V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2483 25.3571H27.8376V26.6546H28.2483V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.031 25.3571H28.6204V26.6546H29.031V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8086 25.3571H29.3979V26.6546H29.8086V25.3571Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2681 23.5719V25.0666H24.6675C24.5615 25.0666 24.4598 25.0245 24.3849 24.9495C24.3099 24.8746 24.2678 24.7729 24.2678 24.6669V23.5719H27.2681Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2519 23.5722H24.2678C24.2748 23.471 24.3199 23.3762 24.3941 23.3071C24.4683 23.238 24.5661 23.1996 24.6675 23.1999H29.8522C29.9536 23.1996 30.0513 23.238 30.1255 23.3071C30.1998 23.3762 30.2449 23.471 30.2519 23.5722Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2519 23.5993V24.6669C30.2519 24.7729 30.2098 24.8746 30.1348 24.9495C30.0599 25.0245 29.9582 25.0666 29.8522 25.0666H27.2681V23.5719H30.2628L30.2519 23.5993Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.122 23.4847H24.7114V24.7823H25.122V23.4847Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9048 23.4847H25.4941V24.7823H25.9048V23.4847Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6823 23.4847H26.2717V24.7823H26.6823V23.4847Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4653 23.4847H27.0547V24.7823H27.4653V23.4847Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2483 23.4847H27.8376V24.7823H28.2483V23.4847Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.031 23.4847H28.6204V24.7823H29.031V23.4847Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8086 23.4847H29.3979V24.7823H29.8086V23.4847Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2681 29.1839V30.6786H24.6675C24.5615 30.6786 24.4598 30.6365 24.3849 30.5615C24.3099 30.4866 24.2678 30.3849 24.2678 30.2789V29.1839H27.2681Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2519 29.1841H24.2678C24.2734 29.0819 24.318 28.9858 24.3924 28.9155C24.4667 28.8452 24.5652 28.8062 24.6675 28.8063H29.8522C29.9545 28.8062 30.053 28.8452 30.1273 28.9155C30.2017 28.9858 30.2462 29.0819 30.2519 29.1841Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2519 29.2168V30.3118C30.2519 30.4178 30.2098 30.5194 30.1348 30.5944C30.0599 30.6693 29.9582 30.7114 29.8522 30.7114H27.2681V29.1839H30.2628L30.2519 29.2168Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.122 29.0963H24.7114V30.3939H25.122V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9048 29.0963H25.4941V30.3939H25.9048V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6823 29.0963H26.2717V30.3939H26.6823V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4653 29.0963H27.0547V30.3939H27.4653V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2483 29.0963H27.8376V30.3939H28.2483V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.031 29.0963H28.6204V30.3939H29.031V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8086 29.0963H29.3979V30.3939H29.8086V29.0963Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2681 31.0508V32.5454H24.6675C24.6148 32.5462 24.5625 32.5363 24.5137 32.5165C24.4649 32.4967 24.4205 32.4673 24.3833 32.43C24.346 32.3927 24.3166 32.3484 24.2968 32.2996C24.277 32.2507 24.2671 32.1984 24.2679 32.1458V31.0508H27.2681Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2519 31.0513H24.2678C24.2748 30.9502 24.3199 30.8554 24.3941 30.7863C24.4683 30.7171 24.5661 30.6788 24.6675 30.679H29.8522C29.9536 30.6788 30.0513 30.7171 30.1255 30.7863C30.1998 30.8554 30.2449 30.9502 30.2519 31.0513Z",
    fill: "#F8EC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2519 31.0782V32.1731C30.2519 32.2791 30.2098 32.3808 30.1348 32.4557C30.0599 32.5307 29.9582 32.5728 29.8522 32.5728H27.2681V31.0508H30.2628L30.2519 31.0782Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.122 30.9632H24.7114V32.2608H25.122V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9048 30.9632H25.4941V32.2608H25.9048V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6823 30.9632H26.2717V32.2608H26.6823V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4653 30.9632H27.0547V32.2608H27.4653V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2483 30.9632H27.8376V32.2608H28.2483V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.031 30.9632H28.6204V32.2608H29.031V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8086 30.9632H29.3979V32.2608H29.8086V30.9632Z",
    fill: "#FCEE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4037 12.4242C24.5402 16.1213 25.1371 17.3511 26.5854 16.1969L22.0364 10.5158L16.6174 10.5649L21.4037 12.4242Z",
    fill: "#F69D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6056 15.3124C30.0313 15.842 30.2901 16.4862 30.3492 17.1631C30.4082 17.8401 30.2648 18.5194 29.9372 19.1147C29.6095 19.71 29.1124 20.1946 28.5089 20.507C27.9055 20.8193 27.2228 20.9454 26.5475 20.8691C25.8723 20.7928 25.2349 20.5177 24.7163 20.0786C24.1977 19.6395 23.8212 19.0563 23.6346 18.4028C23.448 17.7494 23.4597 17.0553 23.6683 16.4086C23.8768 15.7618 24.2728 15.1916 24.8059 14.7703C25.5152 14.2081 26.4182 13.9496 27.3176 14.0512C28.2169 14.1527 29.0395 14.6062 29.6056 15.3124Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6003 19.7001C29.8397 18.7804 30.0988 17.0302 29.1791 15.7909C28.2594 14.5516 26.5092 14.2925 25.2699 15.2121C24.0305 16.1318 23.7714 17.882 24.6911 19.1214C25.6108 20.3607 27.361 20.6198 28.6003 19.7001Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5902 16.1246C28.8526 16.453 29.0118 16.8517 29.0476 17.2705C29.0835 17.6893 28.9943 18.1092 28.7915 18.4774C28.5887 18.8455 28.2813 19.1453 27.9082 19.3387C27.5351 19.5322 27.113 19.6107 26.6952 19.5644C26.2775 19.518 25.8829 19.3488 25.5613 19.0782C25.2396 18.8076 25.0055 18.4478 24.8883 18.0441C24.7712 17.6405 24.7763 17.2111 24.9031 16.8104C25.0299 16.4097 25.2727 16.0556 25.6007 15.7928C25.8187 15.6181 26.069 15.4881 26.3373 15.4103C26.6056 15.3324 26.8866 15.3082 27.1642 15.339C27.4419 15.3699 27.7107 15.4551 27.9554 15.5899C28.2001 15.7247 28.4158 15.9064 28.5902 16.1246Z",
    fill: "#FDCD08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8774 17.0409L23.8035 17.7055L24.4681 17.7795L24.5421 17.1149L23.8774 17.0409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84688 16.065L9.29786 16.4273C11.8624 18.298 15.356 17.7605 15.356 17.7605C18.0962 16.2821 22.2915 16.021 22.2915 16.021C22.63 16.174 22.9541 16.3427 23.2563 16.4941C23.6974 16.7157 24.7782 17.2931 25.131 16.8077C25.588 16.1246 23.9235 13.9601 22.2101 13.2487L18.0958 13.4538C16.5178 11.762 15.6456 9.91113 21.6638 11.6526L25.1037 15.5314C25.7809 16.3786 26.8342 16.4099 27.2196 15.9836C27.4165 15.7612 27.4308 15.3933 27.1549 14.9869C26.3019 13.7415 27.0376 14.8116 23.5763 9.7667C16.5151 6.06006 17.0978 6.65702 11.0794 9.0001L5.00808 9.87741L4.84688 16.065Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36251 8.79184L3.02026 16.4125L7.48198 16.6129L7.82422 8.99221L3.36251 8.79184Z",
    fill: "#5AC8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0390608 8.17412L-0.423096 16.7253L6.3673 17.0303L6.75133 8.47908L-0.0390608 8.17412Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.12707 14.9061C2.13508 14.7601 2.09943 14.6151 2.02467 14.4895C1.94991 14.3639 1.83942 14.2634 1.7073 14.2008C1.57518 14.1383 1.42743 14.1165 1.28289 14.1383C1.13835 14.1601 1.00358 14.2245 0.895781 14.3232C0.787977 14.4219 0.712027 14.5505 0.677621 14.6926C0.643214 14.8346 0.651912 14.9837 0.702604 15.1208C0.753297 15.2579 0.843685 15.3768 0.962236 15.4623C1.08079 15.5478 1.22212 15.5961 1.36822 15.6009C1.56077 15.6085 1.74853 15.5398 1.89065 15.4097C2.03276 15.2795 2.11774 15.0985 2.12707 14.9061Z",
    fill: "#ADCAC6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.9543 0 0 8.9543 0 20C0 20.2679 0.00526809 20.5346 0.0157063 20.8C0.435613 10.1251 9.22222 1.59993 20 1.59993C30.7778 1.59993 39.5644 10.1251 39.9843 20.8C39.9947 20.5346 40 20.2679 40 20C40 8.9543 31.0457 0 20 0Z",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 19.7321 39.9947 19.4654 39.9843 19.2C39.5644 29.8749 30.7778 38.4001 20 38.4001C9.22223 38.4001 0.435616 29.8749 0.0157107 19.2C0.00527371 19.4654 5.58657e-06 19.7321 5.56315e-06 20C4.59751e-06 31.0457 8.95431 40 20 40Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditors);
export default __webpack_public_path__ + "static/media/creditors.838d82f48c12d528417ab21733292c73.svg";
export { ForwardRef as ReactComponent };